module.exports = __webpack_public_path__ + "static/media/3.2620e683.png";